// SPDX-License-Identifier: AGPL-3.0-or-later

import Inbox from '@app/features/inbox/state/Inbox';
import {Switch} from '@app/features/ui/components/form/Switch';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export const InboxTabContent: React.FC = observer(() => {
	const {t} = useLingui();
	return (
		<Switch
			label={t`Skip "Mark all as read" confirmation`}
			description={t`Mark all unread inbox channels as read immediately, without asking to confirm.`}
			value={Inbox.skipMarkAllAsReadConfirmation}
			onChange={(value) => Inbox.setSkipMarkAllAsReadConfirmation(value)}
		/>
	);
});
